import * as React from "react"
import ReactDOM from "react-dom/client"

import App from "App"
import { ServerConfig } from "shared/utils/config"
import { initSentry } from "shared/utils/sentry"

document.addEventListener("DOMContentLoaded", () => {
  const appDataset = document.getElementById("app-data")!.dataset

  const serverConfig = JSON.parse(appDataset.serverConfig!) as ServerConfig
  initSentry(serverConfig)

  const root = ReactDOM.createRoot(document.getElementById("app")!)
  root.render(<App serverConfig={serverConfig} />)
})
